<template>
  <div id="app" v-bind:class="getCurrentTheme">
    <transition name="fade">
      <loading v-show="isLoading"></loading>
    </transition>
    <transition name="fade">
      <router-view/>
    </transition>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CommonMixin from '@/store/module/common/mixin'
import Loading from '@/components/UI/Loading'
import { globalActions as authActions } from '@/store/module/auth/actionTypes'

export default {
  name: 'app',
  mixins: [ CommonMixin ],
  components: {
    [Loading.name]: Loading
  },
  computed: {
    ...mapGetters('company', ['company']),

    getCurrentTheme: function () {
      var result = 'zopone'
      if (this.company && this.company.theme) {
        result = this.company.theme
      } else {
        localStorage.setItem('theme', result)
      }
      return result
    }
  },
  methods: {
    ...mapActions({
      fetchLoggedInUserInfo: authActions.FETCH_USER_INFO
    })
  },
  mounted () {
    // Na rota AuthSSO, o authsso.vue chama fetchUserInfo após o signSSO setar o cookie.
    // Aqui chamaria /me ainda sem cookie → 401. Já é mitigado pelo interceptor, mas pulamos
    // a chamada para evitar request inútil.
    if (this.$route && this.$route.name !== 'AuthSSO') {
      this.fetchLoggedInUserInfo()
    }

    const fDrag = (e) => {
      if (e.target.id !== 'dropzoneId') {
        e.preventDefault()
        e.dataTransfer.effectAllowed = 'none'
        e.dataTransfer.dropEffect = 'none'
      }
    }

    window.addEventListener('dragenter', fDrag)
    window.addEventListener('dragover', fDrag)
    window.addEventListener('dragenter', fDrag)
  }
}
</script>

<style lang="scss">
@import "../scss/style.scss";
@import "../scss/clients/zopone.scss";
@import "../scss/clients/chile.scss";
@import "../scss/clients/jrz.scss";
@import "../scss/clients/cz.scss";
@import "../scss/clients/3z.scss";
@import "../scss/clients/5z.scss";
@import "../scss/clients/6z.scss";
@import "../scss/clients/7z.scss";
@import "../scss/clients/9z.scss";
@import "../scss/clients/10z.scss";
@import "../scss/clients/abda.scss";
@import "../scss/clients/acre.scss";
@import "../scss/clients/acre2.scss";
@import "../scss/clients/aguaazul.scss";
@import "../scss/clients/agr.scss";
@import "../scss/clients/amaparpara.scss";
@import "../scss/clients/amapar2.scss";
@import "../scss/clients/haras.scss";
@import "../scss/clients/laguardia.scss";
@import "../scss/clients/lagos.scss";
@import "../scss/clients/luzped.scss";
@import "../scss/clients/luzfr.scss";
@import "../scss/clients/luzmog.scss";
@import "../scss/clients/riominas.scss";
@import "../scss/clients/rodovia.scss";
@import "../scss/clients/terraflora.scss";
@import "../scss/clients/villaleon.scss";
@import "../scss/clients/villaleon2.scss";
@import "../scss/clients/zimoveis.scss";
@import "../scss/clients/zinc.scss";
@import "../scss/clients/zmais.scss";
@import "../scss/clients/zpav.scss";
@import "../scss/clients/zsites.scss";
@import "../scss/clients/zr1.scss";
@import "../scss/clients/zr2.scss";
@import "../scss/clients/zr3.scss";
@import "../scss/clients/zr5.scss";
@import "../scss/clients/zr6.scss";
@import "../scss/clients/zr11.scss";
@import "../scss/clients/rotaproducao.scss";
@import "../scss/clients/valearinos.scss";
</style>



// WEBPACK FOOTER //
// src/App.vue